import Tooltip from 'tooltip.js'

export const settings = {
  selector: '.js-environment-certificates',
  item: '.js-environment-certificates-item',
  tooltipEl: '.js-environment-certificates-tooltip'
}

/**
 * Function initializes all elements in page.
 */
export default function initAll() {
  let elements = document.querySelectorAll( settings.selector )
  Array.from( elements ).forEach(( element ) => {
    init( element )
  })
}

/**
 * Function initializes single element.
 * @param {DOMNode} element
 */
export function init( element ) {
  const items = element.querySelectorAll( settings.item )
  Array.from( items ).forEach(( item ) => {
    initTooltip( item )
  })
}

/**
 * Init tooltips.
 *
 * @param {DOMNode} element
 */
function initTooltip( element ) {
  const tooltipElement = element.querySelector( settings.tooltipEl )
  const tooltip = tooltipElement.dataset.tooltip
  new Tooltip( tooltipElement, {
    placement: 'top',
    title: tooltip
  })
}
